// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"2de92b8e","109":"d0ce4739","322":"acb99f39","383":"95d72c41","402":"7d7d053c","611":"f4fb431a","623":"204e5288","631":"424821c3","894":"678e5061"}[chunkId] + ".chunk.js";
};